import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-elements-email-notification-settings',
    templateUrl: './elements-email-notification-settings.component.html',
    styleUrls: ['./elements-email-notification-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ElementsEmailNotificationSettingsComponent {
    @Input() value: boolean;
    @Output() toggleSetting: EventEmitter<any> = new EventEmitter();
}
